var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcExmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 38 38"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 16.467,
  stroke: "currentColor",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.013 9.363c.91 0 1.646.737 1.646 1.647v.05l-.319 10.248a1.26 1.26 0 0 1-1.259 1.22 1.273 1.273 0 0 1-1.272-1.22l-.423-10.247a1.636 1.636 0 0 1 1.56-1.698z"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.013,
  cy: 26.805,
  r: 2.533,
  fill: "currentColor"
})));
export default SvgIcExmark;